module.exports = __webpack_public_path__ + "img/logo.52faeb39.png";